export { default } from './BGMTable';
